import React, { useState, useEffect } from "react";
import Footer from "../components/Footer";
import apiClient from "../components/apiClient";
import Breadcrumbs from "../components/Breadcrumbs";
import Navbar from "../components/Navbar";
import DOMPurify from "dompurify";
import { Link } from "react-router-dom";

export const sanitizeHTML = (html) => ({
  __html: DOMPurify.sanitize(html),
});

const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [detailblogs, setDetailBlogs] = useState([]);
  const [sortOrder, setSortOrder] = useState("newest");

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await apiClient.get("/blog");
        let blogsData = res.data.blog || [];

        // Initial sort (newest to oldest)
        blogsData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setBlogs(blogsData);
      } catch (err) {
        console.error("Failed to fetch blogs:", err);
      }
    };

    fetchBlogs();
  }, []);

  useEffect(() => {
    const fetchHighlightBlogs = async () => {
      try {
        const res = await apiClient.get("/blog/show/highlight");
        console.log("API Response:", res.data); // 🔍 add this
        setDetailBlogs(Array.isArray(res.data) ? res.data : [res.data]);
      } catch (err) {
        console.error("Failed to fetch blogs:", err);
      }
    };

    fetchHighlightBlogs();
  }, []);

  const handleSortChange = (e) => {
    const selected = e.target.value;
    setSortOrder(selected);

    const sortedBlogs = [...blogs].sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return selected === "newest" ? dateB - dateA : dateA - dateB;
    });

    setBlogs(sortedBlogs);
  };

  if (!detailblogs) {
    return (
      <div className="text-center py-20 text-gray-500">
        Loading highlighted blog...
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <div className="bg-gray-100 pt-20 md:pt-32 pb-6 md:pb-8">
        {" "}
        {/* Adjusted padding for mobile */}
        <div className="px-4 md:px-6 mx-auto">
          {" "}
          {/* Better container handling */}
          <div className="w-full max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {/* Left Side - Content */}
            {detailblogs.map((blog) => (
              <React.Fragment key={blog.id}>
                <div className="flex flex-col order-2 md:order-1">
                  {" "}
                  {/* <Link to={`/detail-blog/${blog.id}`}> */}
                  <Link to={`/detail-blog`}>
                    <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-800 mb-3 md:mb-4 leading-tight">
                      {blog.judul}
                    </h1>
                  </Link>
                  <span className="text-sm md:text-base text-gray-500">
                    {new Date(blog.createdAt).toLocaleDateString("id-ID", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </span>
                </div>

                {/* Right Side - Image */}

                <div className="w-full h-64 md:h-auto order-1 md:order-2">
                  {" "}
                  <img
                    src={blog.image}
                    alt={blog.judul}
                    className="w-full h-full object-cover rounded-lg md:rounded-none"
                    loading="lazy"
                  />
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-gray-100 flex px-4 md:px-6 pb-2">
        {" "}
        {/* Adjusted breadcrumb padding */}
        <Breadcrumbs />
      </div>

      {/* 4-Column Card Section */}
      <div className="bg-gray-100 py-8 px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[25%_75%] gap-6">
            <div className="overflow-hidden transition-shadow">
              <span>Filter by</span>
              <div className="max-w-xs">
                <label
                  htmlFor="sort-select"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Sort by: Newest to Oldest
                </label>
                <select
                  id="sort-select"
                  value={sortOrder}
                  onChange={handleSortChange}
                  className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                >
                  <option value="newest">Newest to Oldest</option>
                  <option value="oldest">Oldest to Newest</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {blogs.map((blog) => (
                <div
                  key={blog.id}
                  className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow"
                >
                  <Link to={`/blog-detail/${blog.id}`}>
                    <img
                      src={blog.image}
                      alt={blog.judul}
                      className="w-full h-48 object-cover"
                    />
                    <div className="p-4">
                      <h3 className="font-semibold text-lg mb-2">
                        {blog.judul}
                      </h3>
                      <p className="text-gray-600 text-sm line-clamp-2">
                        {blog.meta_desc || "No description"}
                      </p>
                      <p className="mt-2 text-xs text-gray-400">
                        By {blog.adminnama} •{" "}
                        {new Date(blog.createdAt).toLocaleDateString("id-ID", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })}
                      </p>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogPage;
